import React, { useContext, useState } from "react";
import "./style.css";
import { Title } from "../../Components/Atoms";
import { AuthContext } from "../../Library/contexts";
import { useNavigate } from "react-router-dom";
import { Button, useToast } from "@chakra-ui/react";
import PATHS from "../../Routes/paths"
import { SELLER_DES } from "../../Library/constants";
import { getItemFromLocalStorage } from "../../Library/helpers";
import { sendTestPowerWebPush } from "../../APIs";

const PowerOffWebPushTest = () => {
  const Toast = useToast();
  const [sending, setSending] = useState(false);

  const sendTest = () => {
    setSending(true);
    sendTestPowerWebPush()
      .catch(() => Toast({ isClosable: true, description: "Unable to send test notification", position: "bottom", variant: "subtle", duration: 1500 }))
      .finally(() => setSending(false));
  };

  return (
    <div className="panel-card-item power-push-row">
      <label>Power Off Notification:</label>
      <span>
        <Button variant="outline" size="sm" className="power-push-test-btn" onClick={sendTest} isLoading={sending}>
          Send test notification
        </Button>
      </span>
    </div>
  );
};

const Profile = () => {
  const navigate = useNavigate();
  const { profile, assets } = useContext(AuthContext);
  const DESIGNATION = getItemFromLocalStorage("des");
  const IS_USER = getItemFromLocalStorage("user");

  const profileDetails = [
    { key: "Mobile", value: profile.mob },
    { key: "Email", value: profile.eml },
    { key: "GST Number", value: profile.gstno || "-" },
    { key: "Address", value: profile.add },
  ];

  const renderDetails = () => {
    return ((profile && profile.length) ? profile : profileDetails).map((detail) => (
      <div key={detail.key} className="panel-card-item">
        <label>{detail.key}:</label>
        <span>{detail.value}</span>
      </div>
    ));
  };

  return (
    <main className="panel-card-center profile">
      <article className="panel-card">
        <div className="profile-header">
          <Title>{assets.brandNm || profile.brandNm}</Title>
          {
           (IS_USER) ? null : <span className="profile-change-password" onClick={ () => navigate(`${PATHS.CHANGE_PASSWORD}?change=true`)}>Change Password</span>
          }
        </div>
        <div className="mt-16 panel-card-details">
          {renderDetails()}
          {(IS_USER && profile?.webPushAllowed) ? <PowerOffWebPushTest /> : null}
        </div>
      </article>
    </main>
  )
}

export default Profile;
